import { Box, Flex, useBreakpointValue } from '@chakra-ui/react';
import { sizeValues, sizeVars } from '../../constants/layout';
import { SideDrawer } from './SideDrawer';
import type { MenuItemsType } from './MenuItems';
import { useSubSidebar } from './useSubSidebar';

export function SidebarLayout({
  items,
  label,
  showCollapseButton,
  children,
}: {
  items: MenuItemsType[];
  label: string;
  showCollapseButton?: boolean;
  children: React.ReactNode;
}) {
  const { isExpanded } = useSubSidebar();
  const sidebarWidth = useBreakpointValue({
    base: sizeValues.subSidebarSm,
    lg: sizeValues.subSidebar,
  });

  return (
    <Flex height={`calc(100vh - ${sizeVars.navbar})`} flexDir="row">
      <Flex bg="bg.canvas" borderRightWidth={isExpanded ? '1px' : '0px'} minH="100%">
        <SideDrawer items={items} label={label} showCollapseButton={showCollapseButton} />
      </Flex>

      <Box
        width={isExpanded ? `calc(100% - ${sidebarWidth})` : '100%'}
        height="full"
        overflow="auto"
      >
        {children}
      </Box>
    </Flex>
  );
}
